(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-nomitail-product-rating]';

    const getReviewData = (productId) => {
      const reviewWidgets = window.jdgm?.data?.reviewWidget;
      if (!reviewWidgets) return null;
      return reviewWidgets[productId] || reviewWidgets[Number(productId)] || null;
    };

    const normalizeText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

    const moveBetweenTitleAndDescription = (ratingLink) => {
      const productDetails = ratingLink.closest('.product-details');
      if (!productDetails) return;

      const heading = productDetails.querySelector('h1');
      let titleBlock = heading?.closest('.text-block') || heading;

      if (!titleBlock) {
        const expectedTitle = normalizeText(ratingLink.dataset.productTitle);
        titleBlock = [...productDetails.querySelectorAll('.text-block')].find(
          (block) => block.getClientRects().length > 0 && normalizeText(block.textContent) === expectedTitle
        );
      }

      if (
        titleBlock &&
        (ratingLink.parentElement !== titleBlock.parentElement || ratingLink.previousElementSibling !== titleBlock)
      ) {
        titleBlock.insertAdjacentElement('afterend', ratingLink);
      }
    };

    const hideRating = (ratingLink) => {
      ratingLink.dataset.ready = 'false';
      ratingLink.setAttribute('aria-hidden', 'true');
      ratingLink.querySelector('.nomitail-product-rating-summary__stars')?.replaceChildren();
      const count = ratingLink.querySelector('.nomitail-product-rating-summary__count');
      if (count) count.textContent = '';
    };

    const renderStars = (container, rating) => {
      container.replaceChildren();

      for (let position = 1; position <= 5; position += 1) {
        const fill = Math.max(0, Math.min(1, rating - (position - 1))) * 100;
        const star = document.createElement('span');
        star.className = 'nomitail-product-rating-summary__star';
        star.textContent = '★';
        star.style.setProperty('--nomitail-rating-fill', `${fill}%`);
        container.appendChild(star);
      }
    };

    const bindReviewLink = (ratingLink) => {
      if (ratingLink.dataset.reviewLinkBound === 'true') return;
      ratingLink.dataset.reviewLinkBound = 'true';

      ratingLink.addEventListener('click', (event) => {
        const reviewWidget = document.getElementById('judgeme_product_reviews');
        if (!reviewWidget) return;

        event.preventDefault();
        reviewWidget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.history.replaceState(null, '', '#judgeme_product_reviews');
      });
    };

    const initializeRating = (ratingLink, attempt = 0) => {
      if (!(ratingLink instanceof HTMLElement)) return;

      moveBetweenTitleAndDescription(ratingLink);
      bindReviewLink(ratingLink);

      const productId = ratingLink.dataset.productId;
      const reviewData = getReviewData(productId);

      if (!reviewData && attempt < 40) {
        if (ratingLink.dataset.retryScheduled !== 'true') {
          ratingLink.dataset.retryScheduled = 'true';
          window.setTimeout(() => {
            delete ratingLink.dataset.retryScheduled;
            initializeRating(ratingLink, attempt + 1);
          }, 150);
        }
        return;
      }

      if (!reviewData) {
        hideRating(ratingLink);
        return;
      }

      const rating = Math.max(0, Math.min(5, Number(reviewData?.average_rating) || 0));
      const reviewCount = Math.max(0, Number.parseInt(reviewData?.number_of_reviews, 10) || 0);
      const stars = ratingLink.querySelector('.nomitail-product-rating-summary__stars');
      const count = ratingLink.querySelector('.nomitail-product-rating-summary__count');

      if (!stars || !count) return;

      if (reviewCount === 0 || rating === 0) {
        hideRating(ratingLink);
        return;
      }

      renderStars(stars, rating);
      count.textContent = `${reviewCount} ${reviewCount === 1 ? 'review' : 'reviews'}`;
      ratingLink.setAttribute(
        'aria-label',
        `${rating.toFixed(1)} out of 5 stars, ${reviewCount} ${reviewCount === 1 ? 'review' : 'reviews'}. View customer reviews.`
      );
      ratingLink.removeAttribute('aria-hidden');
      ratingLink.dataset.ready = 'true';
    };

    const initializeAllRatings = (scope = document) => {
      if (scope.matches?.(selector)) initializeRating(scope);
      scope.querySelectorAll?.(selector).forEach((ratingLink) => initializeRating(ratingLink));
    };

    const boot = () => {
      initializeAllRatings();

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node instanceof Element) initializeAllRatings(node);
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
      document.addEventListener('shopify:section:load', (event) => initializeAllRatings(event.target));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
